import { render, staticRenderFns } from "./PermissionDataRuleModal.vue?vue&type=template&id=4d8b72ec&scoped=true"
import script from "./PermissionDataRuleModal.vue?vue&type=script&lang=js"
export * from "./PermissionDataRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b72ec",
  null
  
)

export default component.exports